var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"typo-number",on:{"mouseover":function($event){_vm.showTooltip = true},"mouseleave":function($event){_vm.showTooltip = false}}},[_c('span',{staticClass:"product-ean"},[_vm._v(" "+_vm._s(_vm.ean)+" "),(_vm.showTooltip)?_c('div',{staticClass:"product-ean__tooltip"},[_c('h6',[_vm._v(_vm._s(_vm.title))])]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }